// Final review I1 — Review "Onayla" / "Hepsini Onayla" pasiflik kararı (Review.tsx satır bütçesi).
// Backend aynı kuralı 409 `generation_active` ile korur; toplu onay süren bölümü atlar ve sayar.
import type { BulkApproveResponse, ReviewSection } from "@mahir/shared";
import { REVIEW_COPY } from "./review-copy";

const C = REVIEW_COPY.approve;
type ApprovableSection = Pick<ReviewSection, "generationStatus">;

const isGenerating = (s: ApprovableSection): boolean =>
  s.generationStatus === "queued" || s.generationStatus === "running";

/** Tek bölüm onayı — öncelik: KK adayı → kirli editör → süren üretim; null = etkin. */
export function approveDisabledReason(
  section: ApprovableSection,
  hasUnsavedChanges: boolean,
  qcRewriteReady: boolean,
): string | null {
  if (qcRewriteReady) return C.disabledQcPending;
  if (hasUnsavedChanges) return C.disabledDirty;
  if (isGenerating(section)) return C.disabledGenerating;
  return null;
}

/** Toplu onay — herhangi bir bölümde KK adayı ya da süren üretim varsa pasif. */
export function bulkApproveDisabledReason(
  sections: readonly ApprovableSection[],
  anyRewriteReady: boolean,
): string | null {
  if (anyRewriteReady) return C.bulkDisabledQcPending;
  if (sections.some(isGenerating)) return C.bulkDisabledGenerating;
  return null;
}

export function bulkApproveMessage(res: BulkApproveResponse): string {
  return (
    C.bulkDone(res.approvedCount) +
    (res.skippedBusyCount > 0 ? C.bulkSkipped(res.skippedBusyCount) : "")
  );
}
